export default __webpack_public_path__ + "static/testimonial-dan-2f03d444b43a8dc6b9dc7be19f33c3e7.jpg";